import { useRouteError } from 'react-router-dom'
import BrandLogo from '../Brand/BrandLogo'
import { brand } from '../../config/settings/brand'
import routes from '../../config/settings/routes'
import {
  Page,
  Card,
  BrandRow,
  BrandName,
  Code,
  Title,
  Description,
  Actions,
  PrimaryButton,
  SecondaryLink,
} from './NotFound.styles'

function getErrorCode(error) {
  if (!error || typeof error !== 'object') return 'Error inesperado'
  if (error.status) return `Error ${error.status}`
  return 'Error inesperado'
}

export default function Error() {
  const error = useRouteError()

  console.error(error)

  const handleRetry = () => {
    window.location.reload()
  }

  return (
    <Page>
      <Card>
        <BrandRow>
          <BrandLogo size={36} />
          <BrandName>{brand.name}</BrandName>
        </BrandRow>

        <Code>{getErrorCode(error)}</Code>
        <Title>Algo no funcionó</Title>
        <Description>
          No pudimos cargar esta pantalla. Prueba de nuevo en unos segundos.
          Si sigue igual, vuelve al inicio o escríbenos.
        </Description>

        <Actions>
          <PrimaryButton type="button" onClick={handleRetry}>
            Reintentar
          </PrimaryButton>
          <SecondaryLink to={routes.root}>Ir al inicio</SecondaryLink>
          <SecondaryLink to={routes.help}>Contactar soporte</SecondaryLink>
        </Actions>
      </Card>
    </Page>
  )
}
